import { render, staticRenderFns } from "./group-mobie-editor.vue?vue&type=template&id=f7b4b480"
import script from "./group-mobie-editor.vue?vue&type=script&lang=js"
export * from "./group-mobie-editor.vue?vue&type=script&lang=js"
import style0 from "./group-mobie-editor.vue?vue&type=style&index=0&id=f7b4b480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports